"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAlternateLanguageLink = void 0;
function createAlternateLanguageLink(locale, generateTranslationUrl) {
    const translationUrl = generateTranslationUrl(locale);
    if (!translationUrl) {
        return undefined;
    }
    return {
        hrefLang: locale.toHyphenCode(),
        href: translationUrl,
    };
}
exports.createAlternateLanguageLink = createAlternateLanguageLink;
//# sourceMappingURL=createAlternateLanguageLink.js.map